import { render, staticRenderFns } from "./IdcContactManagement.vue?vue&type=template&id=254b33a2&scoped=true&"
import script from "./IdcContactManagement.vue?vue&type=script&lang=js&"
export * from "./IdcContactManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254b33a2",
  null
  
)

export default component.exports